import {CheckPayment} from "../../resources/checkPayments"
import {Customer, CustomerResourceTypes, getCustomerName} from "../../resources/customer"
import {Resource} from "../../resources/common"
import {MetaItemProps} from "../TitleBar/TitleBar"

export const CHECK_PAYMENT_DETAIL_INCLUDE = "customer,account,org"

export function getCheckPaymentHolderIds(checkPayment: CheckPayment): string[] {
	const fromPlural = checkPayment.relationships.customers?.data.map(({id}) => id.toString()) ?? []
	if (fromPlural.length > 0) {
		return fromPlural
	}
	const singular = checkPayment.relationships.customer?.data.id
	return singular ? [singular.toString()] : []
}

export function customersFromIncluded(included?: Resource[]): Customer[] {
	if (!included) {
		return []
	}
	return included.filter((item): item is Customer => CustomerResourceTypes.includes(item.type))
}

export function resolveCheckPaymentCustomers(checkPayment: CheckPayment, included?: Resource[]): Customer[] {
	const holderIds = getCheckPaymentHolderIds(checkPayment)
	const allCustomers = customersFromIncluded(included)
	return holderIds.map((id) => allCustomers.find((c) => c.id === id)).filter((c): c is Customer => c != null)
}

export function getCustomerDetailPath(customer: Customer): string {
	switch (customer.type) {
		case "individualCustomer":
			return `/individual/${customer.id}`
		case "businessCustomer":
			return `/business/${customer.id}`
		case "businessFBOCustomer":
			return `/customers/businessFBO/${customer.id}`
		case "individualWalletCustomer":
			return `/customers/individualWallet/${customer.id}`
		case "businessWalletCustomer":
			return `/customers/businessWallet/${customer.id}`
		default:
			return `/customer/${(customer as Customer).id}`
	}
}

/** Title bar meta links for account holders on a check payment (joint = one link per holder). */
export function buildCheckPaymentCustomerMetaItems(
	checkPayment: CheckPayment,
	resolvedCustomers: Customer[]
): MetaItemProps[] {
	const holderIds = getCheckPaymentHolderIds(checkPayment)

	// Single holder: keep the original generic "Customer" link.
	if (holderIds.length === 1) {
		return [
			{
				text: "Customer",
				icon: "user-geometric-action-money-fund---users",
				path: `/customer/${holderIds[0]}`,
			},
		]
	}

	// Joint: one named link per holder.
	if (resolvedCustomers.length > 0) {
		return resolvedCustomers.map((customer, index) => ({
			text: getCustomerName(customer),
			path: getCustomerDetailPath(customer),
			icon: index === 0 ? "user-geometric-action-money-fund---users" : undefined,
		}))
	}

	return holderIds.map((id, index) => ({
		text: `Customer #${id}`,
		path: `/customer/${id}`,
		icon: index === 0 ? "user-geometric-action-money-fund---users" : undefined,
	}))
}
